import React from 'react';
import { InventoryDragOverlay } from '../../components/InventoryDragOverlay';
import { WorkbenchDragOverlay } from '../../components/WorkbenchDragOverlay';
import { useDragOverlayContext } from '../../app/GameProviders';

export function DragOverlaysPortal() {
  const { inventoryOverlay, workbenchOverlay } = useDragOverlayContext();
  return (
    <>
      <InventoryDragOverlay
        active={inventoryOverlay.active}
        itemId={inventoryOverlay.itemId}
        x={inventoryOverlay.x}
        y={inventoryOverlay.y}
      />
      <WorkbenchDragOverlay
        active={workbenchOverlay.active}
        itemId={workbenchOverlay.itemId}
        instanceId={workbenchOverlay.instanceId}
        x={workbenchOverlay.x}
        y={workbenchOverlay.y}
      />
    </>
  );
}
